// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai_color_swatches[data-v-f9bba520] {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}
.ai_color_swatches .color_selector[data-v-f9bba520] {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiColorSwatches.vue","webpack://./AiColorSwatches.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;ACAF;ADHA;EAMI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;ACAJ","sourcesContent":["\n.ai_color_swatches {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 15px;\n\n  .color_selector {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n}\n",".ai_color_swatches {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 15px;\n}\n.ai_color_swatches .color_selector {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
